import { ChevronRight } from 'lucide-react'
import { Link } from 'react-router'
import { createColumnHelper } from '@tanstack/react-table'
import type { ColumnDef } from '@tanstack/react-table'
import { defaultColumnOptions } from '@/utils/tables'
import Avatar from '@/elements/Avatar'
import Button from '@/elements/Button'
import Pill from '@/elements/Pill'
import Text from '@/elements/Text'
import Flex from '@/elements/Flex'

const columnHelper = createColumnHelper<any>()

export const talentTableColumns: ColumnDef<any, any>[] = [
  columnHelper.accessor('name', {
    ...defaultColumnOptions<any>(),
    header: 'Athlete',
    enableSorting: false,
    cell: info => (
      <Flex inline align='center' gap={2} className='user-cell'>
        <Avatar
          name={info.getValue() as string}
          src={info.row.original.avatarImg}
          notifications={info.row.original.alertsCount || 0}
          size='small'
        />
        <Text variant='textblock'>{info.getValue() as string}</Text>
      </Flex>
    ),
  }),
  columnHelper.accessor('group', {
    ...defaultColumnOptions<any>(),
    header: 'Group',
    enableSorting: false,
  }),
  columnHelper.accessor('location', {
    ...defaultColumnOptions<any>(),
    header: 'Location',
    enableSorting: false,
  }),
  columnHelper.accessor('alertsCount', {
    ...defaultColumnOptions<any>(),
    header: 'Alerts',
    enableSorting: false,
    cell: info => (
      <Pill
        variant='notification'
        notifications={(info.getValue() as number) || 0}
      >
        {(info.getValue() as number) || 0}
      </Pill>
    ),
  }),
  columnHelper.display({
    id: 'actions',
    meta: { width: 'fit-content' },
    cell: info => (
      <div className='actions-cell'>
        <Link to={`/watchdog/${info.row.original.id}`}>
          <Button variant='iconBtn'>
            <ChevronRight size={18} />
          </Button>
        </Link>
      </div>
    ),
    enableSorting: false,
  }),
]
